import { useEffect, useState } from "react";
import { setupMinimalSearchObserver } from "@/autocomplete/utils/headerSearchIntegration";

export function useMinimalSearchVisibility() {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        return setupMinimalSearchObserver(setIsVisible);
    }, []);

    return isVisible;
}